// src/pages/PatientMapComp/PatientDetails/ClinicalContextPanel.jsx
import React from "react";
import {
  Paper,
  Typography,
  Divider,
  Box,
  Stack,
  Chip,
  Tooltip,
} from "@mui/material";

/**
 * ClinicalContextPanel
 * Contenedor visual para mostrar el "Clinical Summary" (insumo clínico factual).
 * Ya NO es un tab. Es el panel superior del workspace derecho.
 *
 * Props opcionales:
 * - contextStatus: { label: string, color?: "default"|"success"|"warning"|"error" }
 * - actions: nodo React para botones (Refresh, Build context, etc)
 */
export default function ClinicalContextPanel({
  title = "Clinical Context",
  subtitle = "Clinical data used as input for AI reports",
  contextStatus = null,
  actions = null,
  children,
}) {
  return (
    <Paper elevation={0} variant="outlined" sx={{ borderRadius: 3, p: 2 }}>
      {/* Header */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
      >
        <Box>
          <Typography fontWeight={900}>{title}</Typography>
          {subtitle && (
            <Typography variant="caption" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>

        <Stack direction="row" spacing={1} alignItems="center">
          {contextStatus?.label && (
            <Tooltip title={contextStatus.tooltip || ""}>
              <Chip
                size="small"
                label={contextStatus.label}
                color={contextStatus.color || "default"}
                variant={contextStatus.variant || "outlined"}
              />
            </Tooltip>
          )}

          {actions}
        </Stack>
      </Stack>

      <Divider sx={{ my: 2 }} />

      {/* Body */}
      <Box>{children}</Box>
    </Paper>
  );
}
